import React from "react"

const ToolbarMenu = ({ close, editor, component }) => {
  const Menu = component

  return (
    <div
      className="absolute bottom-0 left-0"
      style={{ background: "rgb(64, 78, 92)" }}
    >
      <Menu close={close} editor={editor} />
    </div>
  )
}

export default ToolbarMenu
